import { defineMessages } from "react-intl";

const messages = defineMessages({
  cardTitle: {
    id: "dashboard.cards.noContactIn.title",
    defaultMessage:
      "{neverContacted, select, true {No contact <date>yet</date>} other {No contact in over <date>{days} {days, plural, one {day} other {days}}</date>}}",
    description: "Title of the No Contact In card",
  },
  modalTitle: {
    id: "dashboard.editModal.noContactIn.title",
    defaultMessage: "Edit “No Contact In”",
    description: "Title of the Edit No Contact In modal",
  },
});

export default messages;
